import { render, staticRenderFns } from "./SystemUpdateDates.vue?vue&type=template&id=5db57d92"
import script from "./SystemUpdateDates.vue?vue&type=script&lang=js"
export * from "./SystemUpdateDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports